import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, filter, map } from 'rxjs';

import { ApiConfiguration } from '@app/api/api-configuration';
import { RequestBuilder } from '@app/api/request-builder';
import { MerchantsService } from '@app/api/services';
import { StrictHttpResponse } from '@app/api/strict-http-response';

@Injectable({
  providedIn: 'root',
})
export class MerchantsWrapperService extends MerchantsService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  override uploadOperatingLicense$Response(
    params: {
      merchantId: string;
      siteId: string;
      body?: {
        file: Blob;
      };
    },
    context?: HttpContext
  ): Observable<any> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MerchantsService.UploadOperatingLicensePath,
      'put'
    );
    if (params) {
      rb.path('merchantId', params.merchantId, {});
      rb.path('siteId', params.siteId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({
        responseType: 'text',
        accept: '*/*',
        context: context,
        reportProgress: true,
      })
    );
  }
}
